<template>
  <BlockEffects>
    <component :is="blockComponent" v-if="blockComponent" :data="block" />
  </BlockEffects>
</template>

<script setup>
import BlockEffects from './blocks/BlockEffects.vue';
import HeroBlock from './blocks/HeroBlock.vue';
import ServicesBlock from './blocks/ServicesBlock.vue';
import AboutBlock from './blocks/AboutBlock.vue';
import StoryBlock from './blocks/StoryBlock.vue';
import ContactBlock from './blocks/ContactBlock.vue';
import ContactInformationBlock from './blocks/ContactInformationBlock.vue';

const props = defineProps({
  block: {
    type: Object,
    required: true,
    default: {}
  }
});

const blockComponents = {
  hero: HeroBlock,
  services: ServicesBlock,
  about: AboutBlock,
  story: StoryBlock,
  contact: ContactBlock,
  contactfooter: ContactInformationBlock
};

const blockComponent = computed(() => {
  const type = props.block?.type;
  return blockComponents[type] || null;
});
</script>
